export const SkipIcon = (props) => {
  return (
    <svg {...props} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.20588 1.20588L7.79412 7.79412" stroke="black" strokeLinecap="square" />
      <path d="M7.79412 1.20588L1.20588 7.79412" stroke="black" strokeLinecap="square" />
    </svg>
  );
};
